import * as React from 'react'
import {ButtonAsync} from '@frontrow/console/src/components/button-async'
import {H3} from '@frontrow/console/src/components/typography'

// Models
import {type DistrictT} from '@frontrow/console/src/models/district'
import {type ImportFileType} from '@frontrow/console/src/components/pages/roster-page/import-row'
// Components
import ImportRow from '@frontrow/console/src/components/pages/roster-page/import-row'
import WarningIcon from '@frontrow/console/src/components/common/warning-icon'
import DistrictSearchButtonContainer from '@frontrow/console/src/components/common/district-search-button'
import * as style from './csv-upload.module.scss'

type Props = {
  setDistrictId: (districtId: number) => void
  handleImportFile: (file: File, fileType: ImportFileType) => void
  districtIdIsSet: boolean
  teachersCsvIsUploaded: boolean
  studentsCsvIsUploaded: boolean
  coursesCsvIsUploaded: boolean
  enrollmentsCsvIsUploaded: boolean
  handleSubmit: () => Promise<void>
}

export default function RosterSyncCsvUpload(props: Props): React.ReactElement {
  const {
    setDistrictId,
    handleImportFile,
    teachersCsvIsUploaded,
    studentsCsvIsUploaded,
    coursesCsvIsUploaded,
    enrollmentsCsvIsUploaded,
    districtIdIsSet,
    handleSubmit
  } = props

  const [districtLabel, setDistrictLabel] = React.useState<string | undefined | null>(null)

  const onPostDistrictFetch = (districts: Array<DistrictT>) => {
    if (districts.length === 0) {
      setDistrictLabel('District not found')
    } else if (districts.length === 1) {
      const district = districts[0]
      setDistrictLabel(district.name)
      setDistrictId(district.id)
    } else {
      const firstDistrict = districts[0]
      throw new Error(`found multiple districts with id ${firstDistrict.id}`)
    }
  }

  const districtInfo =
    districtLabel !== null && districtLabel !== undefined ? (
      <H3 addClass={style.districtInfo}>{districtLabel}</H3>
    ) : null

  return (
    <React.Fragment>
      <p>
        <WarningIcon />
        &nbsp;Make sure SIS IDs have been updated before rostering
      </p>
      <div className={style.searchButtonWrapper}>
        <DistrictSearchButtonContainer onPostFetch={onPostDistrictFetch} />
        {districtInfo}
      </div>
      <ImportRow
        title="Teachers"
        type="teachers-csv"
        onImport={handleImportFile}
        uploaded={teachersCsvIsUploaded}
        description="school_id,first_name,last_name,teacher_email"
        templateUrl=""
      />
      <ImportRow
        title="Students"
        type="students-csv"
        onImport={handleImportFile}
        uploaded={studentsCsvIsUploaded}
        description="student_sis_id,first_name,last_name,grade"
        templateUrl=""
      />
      <ImportRow
        title="Courses"
        type="courses-csv"
        onImport={handleImportFile}
        uploaded={coursesCsvIsUploaded}
        description="teacher_email,course_sis_id,name"
        templateUrl=""
      />
      <ImportRow
        title="Enrollments"
        type="enrollments-csv"
        onImport={handleImportFile}
        uploaded={enrollmentsCsvIsUploaded}
        description="student_sis_id,course_sis_id"
        templateUrl=""
      />
      <ButtonAsync
        onClick={handleSubmit}
        type="submit"
        style="primary"
        disabled={
          !(
            teachersCsvIsUploaded &&
            studentsCsvIsUploaded &&
            coursesCsvIsUploaded &&
            enrollmentsCsvIsUploaded &&
            districtIdIsSet
          )
        }
      >
        Preview Rostering
      </ButtonAsync>
    </React.Fragment>
  )
}
